/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SystemServiceType = {
    NotSpecified: 'NotSpecified',
    FcrUp: 'FcrUp',
    FcrDown: 'FcrDown',
    AfrrUp: 'AfrrUp',
    AfrrDown: 'AfrrDown',
    MfrrUp: 'MfrrUp',
    MfrrDown: 'MfrrDown',
} as const;
export type SystemServiceType = typeof SystemServiceType[keyof typeof SystemServiceType];

